import { buildApiUrl, getAuthHeaders } from "@/config/api";

export interface Viewer { id: string; name?: string; email?: string; }

class DealViewerService {
  async add(dealId: string, userIds: string[]): Promise<void> {
    if (!userIds?.length) return;
    const res = await fetch(buildApiUrl(`/deals/${dealId}/viewers`), {
      method: "POST",
      headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
      body: JSON.stringify({ userIds }),
    });
    if (!res.ok) throw new Error(`Add viewers failed: ${res.status} ${await res.text()}`);
  }

  async list(dealId: string): Promise<Viewer[]> {
    const res = await fetch(buildApiUrl(`/deals/${dealId}/viewers`), {
      method: "GET",
      headers: getAuthHeaders(),
    });
    if (!res.ok) throw new Error(`Fetch viewers failed: ${res.status} ${await res.text()}`);
    const json = await res.json();
    const arr = json.viewers ?? json.data ?? [];
    return arr.map((u: any) => ({ id: u.id, name: u.name ?? `${u.firstName ?? ""} ${u.lastName ?? ""}`.trim(), email: u.email }));
  }

  async remove(dealId: string, userId: string): Promise<void> {
    const res = await fetch(buildApiUrl(`/deals/${dealId}/viewers/${userId}`), {
      method: "DELETE",
      headers: getAuthHeaders(),
    });
    if (!res.ok) throw new Error(`Remove viewer failed: ${res.status} ${await res.text()}`);
  }
}

export const dealViewerService = new DealViewerService();
export default dealViewerService;
